/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
 import { createHandlerChainRunner, Handler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
 import { validateResourcesPagePassword, ValidateResourcesPagePasswordParameter } from "@monsma/App/Services/ValidateResourcesPagePasswordService";
 
 type Parameter = ValidateResourcesPagePasswordParameter & HasOnSuccess<any> & HasOnError<unknown>;
 
 type Props = {
     apiParameter: ValidateResourcesPagePasswordParameter;
     apiResult: any;
     error?: any;
 };
 
 type HandlerType = Handler<Parameter, Props>;
 
 export const PopulateApiParameter: HandlerType = props => {
     props.apiParameter = {
         ...props.parameter,
     };
 };
 
 export const RequestDataFromApi: HandlerType = async props => {
     try {
         props.apiResult = await validateResourcesPagePassword(props.apiParameter);
     } catch (e) {
         props.error = true;
     }
 };
 
 export const ExecuteOnSuccessCallback: HandlerType = props => {
     if (!props.error) {
         props.parameter.onSuccess?.(props.apiResult);
     }
 };
 
 export const ExecuteOnErrorCallback: HandlerType = props => {
     if (props.error) {
         props.parameter.onError?.(props.error);
     }
 };
 
 export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];
 
 const checkPassword = createHandlerChainRunner(chain, "CheckPassword");
 export default checkPassword;
 